type AnyFunction = (...args: any[]) => any;

export class PubSub<T extends AnyFunction = (...args: unknown[]) => unknown> {
    private subscribers: T[];

    constructor() {
        this.subscribers = [];

        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.publish = this.publish.bind(this);
    }

    subscribe(subscriber: T) {
        this.subscribers.push(subscriber);

        return () => this.unsubscribe(subscriber);
    }

    private unsubscribe(subscriber: T) {
        this.subscribers = this.subscribers.filter((sub) => sub !== subscriber);
    }

    publish(...args: Parameters<T>) {
        this.subscribers.forEach((subscriber) => {
            subscriber(...args);
        });
    }
}
